import axios from 'axios'

export default axios.create({
  timeout: 25000,
})

export { default as readFromBucket } from './readFromBucket/readFromBucket'
